import { FirebaseDocRefType, FirebaseDocumentDataType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { dateToString } from 'lib/helper'
import { fetchStocksAction } from 'reducks/stock/actions'
import { mergeStocks } from 'reducks/stock/operations'
import { StockUnionType } from 'types/stock'

const fetchStocksWithinPeriod = (params: {
  storeRef: FirebaseDocRefType
  type: StockUnionType
  startOfMonth: Date
  endOfMonth: Date
  isExcludingDeletedStock?: boolean
}) => {
  const { storeRef, type, startOfMonth, endOfMonth, isExcludingDeletedStock = true } = params
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const manufacturerRef = getState().auth.manufacturer_ref
    let query = storeRef.collection('store_stocks').where('type', '==', type)
    if (typeof manufacturerRef !== 'undefined') {
      query = query.where('manufacturer_ref', '==', manufacturerRef)
    }
    const stocks = await query
      .orderBy('date', 'asc')
      .startAt(dateToString(startOfMonth))
      .endAt(dateToString(endOfMonth))
      .get()
      .then((snapshots: FirebaseDocumentDataType) => {
        return mergeStocks(snapshots, isExcludingDeletedStock)
      })
      .catch((error: unknown) => {
        console.error(error)
        return []
      })

    dispatch(fetchStocksAction(stocks))
  }
}

export default fetchStocksWithinPeriod
